import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import { Autoplay, Keyboard, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import clientImage from "../../assets/avatar/avatar.png";
import "./Client.css";

const Client = () => {
  return (
    <section className="client-testimonials" aria-labelledby="testimonial-heading">
      {/* Section Title */}
      <header className="section-title">
        <h2 id="testimonial-heading" className="section-heading">
          Testimonial
        </h2>
        <p className="section-subheading">
          What our clients are saying
        </p>
      </header>

      {/* Slider */}
      <div className="testimonial-slider">
        <Swiper
          spaceBetween={40}
          slidesPerView={1}
          loop
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          navigation
          keyboard={{ enabled: true }}
          modules={[Navigation, Pagination, Autoplay, Keyboard]}
        >
          {[
            {
              text:
                "Thank You for the software development which was timely executed and successfully presented as per the requirement. I personally thank Team IQApex for timely delivery of hardware product and immense support as and when required. The work done by the IQApex team is commendable.",
              name: "Subrata Pathak",
              company:
                "Associate Engg at Bharat Electronics, Ex - Chief, Indian Navy",
            },
            {
              text:
                "I have been working with your team for the duration of this project and I am thankful to Team IQApex for their rigorous work. The response during bug resolution was truly invaluable.",
              name: "Himalaya Mukherjee",
              company: "Project Manager at Golicit",
            },
            {
              text:
                "Great Going Team IQApex. Your team's dedication & hard work in R&D, especially hardware, attracts me the most. Wishing you all the best!",
              name: "Aman Gupta",
              company: "Product Manager at Moglix",
            },
            {
              text:
                "The web-based app developed by Team IQApex has taken my business to new heights. Thank you for such great efforts.",
              name: "Brojen Kumar Singh",
              company: "Import / Export",
            },
            {
              text:
                "The work couldn’t have been done in a better way. The team handled the project professionally and understood all my requirements.",
              name: "Arun Kumar Singh",
              company: "National Yoga Trainer",
            },
          ].map((item, index) => (
            <SwiperSlide key={index}>
              <article className="testimonial">
                <img
                  className="client-image"
                  src={clientImage}
                  alt={`Client ${item.name}`}
                />

                <FaQuoteLeft className="quote-icon" />

                <p className="testimonial-text">{item.text}</p>

                <h3 className="testimonial-author">{item.name}</h3>
                <p className="testimonial-company">{item.company}</p>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Client;
